import { PiSpinnerThin } from "react-icons/pi";
// 現象選択画面でGoボタンを押下した際のローディング画面
export const Loading = () => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-75">
      <div className="flex items-center justify-center">
        <PiSpinnerThin size={100} className="animate-spin" />
      </div>
    </div>
  );
};
